import React from "react";
import Txn from "./Txn";
import { ListHeader, OpenCloseBalance } from "components";

const TxnsTView = ({
  txns = [],
  monthlyCash = { in: "₹ 0", out: "₹ 0" },
  openBalance = 0,
  closeBalance = 0,
}) => {
  return (
    <div className="row p-0 m-0 w-100">
      {/* Incoming transactions */}
      <div
        className="col-6 list-group list-group-flush overflow-auto scrollbar-design"
        style={{
          height: "calc(100vh - 141px)",
          // maxHeight: "calc(100vh - 134px)",
        }}
      >
        <ListHeader type="in" amount={monthlyCash.in} title="Received" />
        <OpenCloseBalance type="open" sum={openBalance} />
        {txns
          ?.filter(
            (txn) =>
              (txn.get ? txn.get("amount") : txn.amount) > 0 &&
              !(txn.get ? txn.get("cancelled") : txn.cancelled)
          )
          .map((txn, i) => (
            <Txn data={txn} key={txn.id || i} />
          ))}
      </div>

      {/* Outgoing transactions */}
      <div
        className="col-6 list-group list-group-flush overflow-auto scrollbar-design"
        style={{
          height: "calc(100vh - 141px)",
          // maxHeight: "calc(100vh - 134px)",
        }}
      >
        <ListHeader type="out" amount={monthlyCash.out} title="Given" />
        {txns
          ?.filter(
            (txn) =>
              (txn.get ? txn.get("amount") : txn.amount) < 0 &&
              !(txn.get ? txn.get("cancelled") : txn.cancelled)
          )
          .map((txn, i) => (
            <Txn data={txn} key={txn.id || i} />
          ))}
        <OpenCloseBalance type="close" sum={closeBalance} />
      </div>
    </div>
  );
};

export default TxnsTView;
